import { useMemo } from 'react';
import { Badge } from '../interfaces/users.interface';
import moment from 'moment';
import { BLUE_BADGE_LABEL, BLUE_NEXT_GEN_BADGE_IMAGE, BadgeMeta, initialBadgeMeta } from '../services/badge';

export function useRegistryBadges(badges: Badge[]):  BadgeMeta[] {
  const badgeMap = useMemo(() => {
    const map: Record<string, BadgeMeta> = Object.fromEntries(
      Object.entries(initialBadgeMeta).map(([key, meta]) => [
        key,
        { ...meta, expirationDate: null },
      ]),
    );

    badges.forEach(badge => {
      const entry = map[badge.title];
      if (!entry) return;

      if (badge.title === BLUE_BADGE_LABEL && badge?.isNextGen) {
        entry.isNextGen = true;
      }

      const currDate = moment(entry.expirationDate).isValid() ? moment(entry.expirationDate) : moment('1970-01-01');
      const nextDate = moment(badge.expirationDate);
      if (badge.expirationDate != null && nextDate.isAfter(currDate)) {
        entry.expirationDate = badge.expirationDate;
      }

      entry.count++;

      if (nextDate.isBefore(moment())) {
        entry.count_expired++;
      }
    });

    return map;
  }, [badges]);

  // If blue badge is nextGen set correct image
  if (badgeMap[BLUE_BADGE_LABEL].isNextGen) {
    badgeMap[BLUE_BADGE_LABEL].image = {
      src: BLUE_NEXT_GEN_BADGE_IMAGE,
      alt: 'Blue (NextGen) Shield Logo',
    };
  }

  const registryBadges = useMemo(() => {
    return Object.entries(badgeMap).map(([title, meta]) => ({
      ...meta,
      title,
      expired: meta.expirationDate ? moment(meta.expirationDate).isBefore(moment()) : false,
    }));
  }, [badgeMap]);

  return registryBadges;
}
